import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import SignupForm from '@disco/accounts/components/auth/SignupForm'
import { isLoggingInFromAccountsSubdomain } from '@disco/api/utils/auth'
import captureError from '@disco/utils/captureError'

import BrowserModal from 'components/browser-modal'
import CookiesDisabled from 'components/cookies-disabled'
import DocumentHeadTags from 'components/document-head-tags'
import { DiscoStackLoader, Flex } from 'components/ds'
import ErrorPage from 'components/error-page'
import CookieBanner from 'components/modals/cookie-banner'

const Signup = () => {
  const navigate = useNavigate()
  const [isReady, setIsReady] = useState(false)
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    let cancelled = false

    async function init() {
      if (!isLoggingInFromAccountsSubdomain()) {
        navigate('/')
      } else {
        try {
          await import('@disco/accounts/styles/tailwind.css')
        } catch (error) {
          if (!cancelled) setHasError(true)
          captureError(error, {
            description: 'tailwind styles failed to load in /signup',
          })
        } finally {
          if (!cancelled) setIsReady(true)
        }
      }
    }
    init()

    return () => {
      cancelled = true
    }
  }, [navigate])

  if (!isReady) {
    return (
      <Flex height="100vh" align="center" justify="center">
        <DiscoStackLoader />
      </Flex>
    )
  }

  if (hasError) {
    return (
      <ErrorPage
        title="Internal error"
        description={
          <span>
            DISCO has encountered an internal error and the team have been
            notified.
          </span>
        }
      />
    )
  }

  return (
    <div>
      <DocumentHeadTags title="Signup | DISCO" />
      <CookiesDisabled />
      <BrowserModal />
      <CookieBanner location="Signup" />

      <SignupForm />
    </div>
  )
}

export default Signup
